import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import apiUrl from "../../api-url";
import axios from "axios";

const STORE_MOUNT_POINT = "savedSearch";

const SAVED_SEARCH_URL = apiUrl("/preferences-ng/search-history");

const savedSearchDuck = buildFetchDuck("savedSearch");

export function fetchSavedSearches() {
  return dispatch => {
    dispatch(savedSearchDuck.fetch(SAVED_SEARCH_URL));
  };
}

const saveSearch = (name, searchObj) => {
  const payload = { name, search: searchObj };
  return dispatch => {
    console.log(payload);
    return axios
      .post(`${SAVED_SEARCH_URL}`, payload)
      .then(responses => {
        dispatch(fetchSavedSearches());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
};

export function editSearch(id, name = null, searchObj = null) {
  let payload = {};
  if (name != null) {
    payload["name"] = name;
  }
  if (searchObj != null) {
    payload["search"] = searchObj;
  }

  return dispatch => {
    return axios
      .put(`${SAVED_SEARCH_URL}/${id}`, payload)
      .then(responses => {
        dispatch(fetchSavedSearches());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
}

export function deleteSearch(id) {
  return dispatch => {
    return axios
      .delete(`${SAVED_SEARCH_URL}/${id}`)
      .then(responses => {
        dispatch(fetchSavedSearches());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
}

// selectors
const getSavedSearches = state => {
  return state.savedSearch.data;
};

export default {
  mountPoint: STORE_MOUNT_POINT,
  actionCreators: {
    fetchSavedSearches,
    saveSearch,
    editSearch,
    deleteSearch
  },
  selectors: {
    getSavedSearches
  },
  reducer: savedSearchDuck.reducer
};



// WEBPACK FOOTER //
// ./src/modules/shipment-search/SavedSearchState.js